
import LoginAdmin from './loginAdmin'
import DashBoard  from './dashboard'
import Parceiros from './parceiros'
import Servicos from './servicos'
import Motoristas from './motoristas'
import Indicacoes from './indicacoes'
import Promocoes from './promocoes'

export default {
    LoginAdmin, 
    DashBoard, 
    Motoristas, 
    Indicacoes, 
    ...Promocoes, 
    ...Parceiros, 
    ...Servicos, 

}
